export default __webpack_public_path__ + "static/media/Class-10-State-Kanada.ebc53bb5.pdf";